import { S } from '../core/state.js';
import { installMode, promptInstall } from './install.js';
import { quietStart } from './quiet-start.js';
import { where } from '../world/places.js';
const KEY = 'unige:install-offer:v1';
let timer, root, joinedAt = 0, sessionShown = false, cfg = { on: false, delaySeconds: 12, snoozeDays: 7 };
function read() {
  try { const value = JSON.parse(localStorage.getItem(KEY) || '{}'); return value && typeof value === 'object' ? value : {}; }
  catch { return {}; }
}
function write(value) { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* suppressed for this session */ } }
function remove() { root?.remove(); root = null; }
function schedule() { clearTimeout(timer); timer = setTimeout(check, 1000); }
/**
 * R126(레드팀 C5) — 설치 카드는 **첫 귀환 뒤**에 뜬다. 전에는 들어오고 12초면 떴다 — 스토리 카드·첫 사냥과 겹치는 자리다.
 * 한 번이라도 마을 밖(사냥터)에 나갔다가 마을로 돌아온 뒤여야 「이 세계로 바로 돌아온다」가 뜻을 갖는다.
 * 이 기기에서 한 번 돌아왔으면 기억한다(다음 접속부터는 기다리지 않는다).
 */
let wentOut = false;
function returnedOnce() {
  const pref = read();
  if (pref.returned === true) return true;
  const at = S.you ? where(S.you) : 'out';
  if (at === 'out') { wentOut = true; return false; }
  if (wentOut && at === 'town') { write({ ...pref, returned: true }); return true; }
  return false;
}
function blocked() {
  return !S.connected || !S.you || S.you.dead > 0 || S.you.hp <= 0 || S.panel || document.hidden || quietStart() || !returnedOnce() ||
    !!document.querySelector('#world-story.on, #dead.on, #adminview.on, #link.on, dialog[open]');
}
function later() { write({ ...read(), until: Date.now() + cfg.snoozeDays * 86400000 }); remove(); }
function check() {
  const pref = read();
  if (!cfg.on || pref.never === true || pref.until > Date.now() || !installMode()) {
    if (root) remove();
    // A supporting browser may provide its one-shot event after the game init.
    if (cfg.on && !sessionShown && pref.never !== true && !(pref.until > Date.now())) schedule();
    return;
  }
  if (root) { root.hidden = blocked(); schedule(); return; }
  if (sessionShown) return;
  if (blocked() || Date.now() < joinedAt + cfg.delaySeconds * 1000) { schedule(); return; }
  sessionShown = true;
  const card = document.createElement('aside'); root = card;
  card.id = 'install-offer'; card.setAttribute('aria-label', '바탕화면에 추가');
  card.innerHTML = '<button class="install-close" aria-label="나중에 안내">×</button><div class="install-heading"><img src="/icon-192.png" alt=""><div><strong>바탕화면에 유니지 추가</strong><p>아이콘을 누르면 이 세계로 바로 돌아온다.</p></div></div><p class="install-guide" hidden>브라우저의 공유 메뉴를 열고 <b>홈 화면에 추가</b>를 골라 달라.</p><div class="install-actions"><button class="install-primary">' + (installMode() === 'ios' ? '추가 방법' : '설치하기') + '</button><button class="install-later">나중에</button><button class="install-never">다시 묻지 않기</button></div>';
  card.addEventListener('pointerdown', e => e.stopPropagation());
  card.addEventListener('click', e => e.stopPropagation());
  card.addEventListener('keydown', e => { e.stopPropagation(); if (e.key === 'Escape') { e.preventDefault(); later(); } });
  card.querySelector('.install-close').onclick = later; card.querySelector('.install-later').onclick = later;
  card.querySelector('.install-never').onclick = () => { write({ never: true }); remove(); };
  card.querySelector('.install-primary').onclick = async () => {
    if (installMode() === 'ios') { card.querySelector('.install-guide').hidden = false; card.querySelector('.install-primary').hidden = true; card.querySelector('.install-later').focus(); return; }
    const button = card.querySelector('.install-primary'); button.disabled = true;
    // promptInstall calls the native prompt synchronously from this click. Choice
    // acceptance is not proof of installation; only appinstalled/standalone is.
    await promptInstall();
    later();
  };
  document.body.append(card); schedule();
}
/** Real init/config packets supply the server policy. Reconnect cannot repeat a shown card. */
export function configureInstallOffer(value) {
  cfg = { ...cfg, ...value };
  if (!joinedAt) joinedAt = Date.now();
  if (!cfg.on) { clearTimeout(timer); remove(); return; }
  schedule();
}
addEventListener('appinstalled', () => { clearTimeout(timer); sessionShown = true; remove(); });
addEventListener('unige:logout', () => { clearTimeout(timer); remove(); });
